export default __webpack_public_path__ + "static/media/leaderboard-tnc-cn.dc3f137b.svg";